module.exports = __webpack_public_path__ + "img/galery-smart-scan-3-zoom.87041a94.png";